import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import "./index.scss";

import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Container, Input } from "reactstrap";
import { setLanguage as setUserLanguage } from "../../../../app/store/settingSlice";
import Logo from "../../../../assets/icons/logo-new.svg";
import mobile from "../../../../assets/icons/mobile-log-seo.svg";
import LanguageIconen from "../../../../assets/images/language-english.png";
import LanguageIcon from "../../../../assets/images/language-vietnamese.png";
import useWindowSize from "../../../customHooks/useWindowSize";

function Header({ t, user }) {
  const dispatch = useDispatch();
  const defaultLanguage = useSelector(({ setting }) => setting.language);

  const [hideMenu, setHideMenu] = useState(false);
  const [language, setLanguage] = useState(defaultLanguage);
  const [widthscreen] = useWindowSize();
  const location = useLocation();
  const qanda =
    location.search === "?utm_source=Qanda&utm_medium=referral" &&
    location.search;

  useEffect(() => {
    i18next.changeLanguage(language);
  }, [language]);

  return (
    <Container
      className="header-blocks-new position-relative px-0"
      fluid={true}
    >
      {/* Mobile */}
      <div className={`small-menu position-fixed ${hideMenu && "full-menu"}`}>
        <ul className="list-unstyled pt-3">
          <li className="hover text-right pe-3">
            <FontAwesomeIcon
              className="text-light h4 mb-0"
              onClick={() => setHideMenu(false)}
              icon={["fas", "times"]}
            />
          </li>
          <li className="hover">
            <a
              className="d-inline-block h-100 w-100 text-decoration-none text-light text-bold2 mb-3 ps-3"
              href={`/#Trangchu${qanda ? qanda : ""}`}
              alt="home"
            >
              {t("nav_home")}
            </a>
          </li>
          <li className="hover">
            <a
              className="d-inline-block h-100 w-100 text-decoration-none text-light text-bold2 mb-3 ps-3"
              href={`/#tinhnang${qanda ? qanda : ""}`}
              alt="feature"
            >
              {t("nav_about_us")}
            </a>
          </li>
          <li className="hover">
            <a
              className="d-inline-block h-100 w-100 text-decoration-none text-light text-bold2 mb-3 ps-3"
              href={`/#chiphi${qanda ? qanda : ""}`}
              alt="cost"
            >
              {t("nav_cost")}
            </a>
          </li>
          <li className="hover">
            <a
              className="d-inline-block h-100 w-100 text-decoration-none text-light text-bold2 mb-3 ps-3"
              href={`/#faq${qanda ? qanda : ""}`}
              alt="Contact"
            >
              {t("nav_faq")}
            </a>
          </li>
          <li className="hover"></li>
        </ul>
      </div>

      {/* Desktop */}
      <Link to="/">
        <div className="header-blocks-new__logo">
          <div className="logo-container">
            <div className="logo center-box">
              <img src={widthscreen < 887 ? mobile : Logo} alt="logo" />
            </div>
          </div>
        </div>
      </Link>

      <div className="header-blocks-new__navbar">
        <ul className="flex-box justify-content-between">
          <li
            onClick={() => setHideMenu(!hideMenu)}
            className="menu-icon d-none cursor-pointer h4 mb-0"
          >
            <FontAwesomeIcon icon={["fas", "bars"]} />
          </li>
          <li className="empty-item" style={{ width: "180px" }}></li>
          <li className="hover hidden-item">
            <a
              className="d-inline-block h-100 w-100"
              href={`/#Trangchu${qanda ? qanda : ""}`}
              alt="home"
            >
              {t("nav_home")}
            </a>
          </li>
          <li className="hover hidden-item">
            <a
              className="d-inline-block h-100 w-100"
              href={`/#tinhnang${qanda ? qanda : ""}`}
              alt="feature"
            >
              {t("nav_about_us")}
            </a>
          </li>
          <li className="hover hidden-item">
            <a
              className="d-inline-block h-100 w-100"
              href={`/#chiphi${qanda ? qanda : ""}`}
              alt="cost"
            >
              {t("nav_cost")}
            </a>
          </li>
          <li className="hover hidden-item">
            <a
              className="d-inline-block h-100 w-100"
              href={`/#faq${qanda ? qanda : ""}`}
              alt="Contact"
            >
              {t("nav_faq")}
            </a>
          </li>
          <li className="language-box border px-2 border-radius-2 flex-box me-2">
            <img
              src={language === "en" ? LanguageIconen : LanguageIcon}
              width={36}
              height={24}
              alt="language icon"
            />

            <Input
              className="border-0 text-dark bg-light cursor-pointer pe-4"
              type="select"
              value={language}
              onChange={(e) => {
                setLanguage(e.target.value);
                dispatch(setUserLanguage(e.target.value));
                localStorage.setItem("language", e.target.value);
              }}
            >
              <option value="vi">{t("landing-page:nav_languages_vi")}</option>
              <option value="en">{t("landing-page:nav_languages_en")}</option>
            </Input>
          </li>
          <li className="text-nowrap ">
            <NavLink
              className="login-btn me-3"
              to={qanda ? `/user/login${qanda}` : "/user/login"}
            >
              {t("nav_login_btn")}
            </NavLink>
            <span className="giasu-static text-bold2">
              <NavLink to={`${user ? "/" : "/giasu"}${qanda ? qanda : ""}`}>
                {user ? "Học viên" : "Gia sư"}
              </NavLink>
            </span>
          </li>
        </ul>
      </div>
    </Container>
  );
}

export default Header;
